import React from "react";
import ReactDOM from "react-dom";
import Backdrop from "../Backdrop";
import { CSSTransition } from "react-transition-group";
import style from "./index.module.scss";

const DialogOverlay = (props) => {
  const content = (
    <div className={style["dialog"]}>
      <div className={style[`dialog__content`]}>{props.children}</div>
    </div>
  );

  return ReactDOM.createPortal(content, document.getElementById("dialog-hook"));
};

const Dialog = (props) => {
  return (
    <>
      {props.isOpen ? <Backdrop onClick={props.toggleModal}></Backdrop> : ""}

      <CSSTransition
        in={props.isOpen}
        mountOnEnter
        unmountOnExit
        timeout={50}
        classNames="dialog"
      >
        <DialogOverlay {...props}></DialogOverlay>
      </CSSTransition>
    </>
  );
};

export default Dialog;
